import { render, staticRenderFns } from "./donationDetail.vue?vue&type=template&id=70dee25c&scoped=true"
import script from "./donationDetail.vue?vue&type=script&lang=js"
export * from "./donationDetail.vue?vue&type=script&lang=js"
import style0 from "./donationDetail.vue?vue&type=style&index=0&id=70dee25c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dee25c",
  null
  
)

export default component.exports